import {
  assert_array_includes,
  assert_number_gte_0,
  assert_true,
  assert_type_boolean,
  assert_type_enum,
  assert_type_string,
} from '@shared/asserts/utils_asserts';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { FIELD_OF_TYPE } from '@shared/types/types';
import { MAP__serializable } from '../../_base/MAP__serializable';
import { ENUM__sort_direction } from '../../_database_entity/ENUM__sort_direction';
import { DTODiffusionModelUDBase } from '../sd/_base/dto_diffusion_model_ud_base';
import { DTODiffusionModelsTablePageSettingsBase } from '../table_base/dto_diffusion_models_table_page_settings_base';

export class DTODiffusionModelsTablePageSettingsUD extends DTODiffusionModelsTablePageSettingsBase {
  /*
   * STATIC FIELDS
   */

  static readonly _class_name_static: string = ENUM__dto_class_name.DIFFUSION_MODELS_TABLE_PAGE_SETTINGS_UD;

  /*
   * FIELDS
   */
  //"" = all
  filter_floating_point_precision!: string;
  //"" = all
  filter_base_model!: string;
  //"" = all
  filter_query!: string;

  filter_show_only_used!: boolean;

  //key - column name, value - sort direction: -1 or 1
  sort_columns_map: MAP__serializable<FIELD_OF_TYPE<DTODiffusionModelUDBase>, number>;

  /*
   * PROPERTIES
   */

  get fields_ignored_in_hash(): Set<string> {
    let out = super.fields_ignored_in_hash;

    out.add('index_page');

    return out;
  }

  /*
   * METHODS
   */

  constructor() {
    super();
    this.sort_columns_map = new MAP__serializable();
  }

  assert_standard_fields() {
    super.assert_standard_fields();

    assert_type_string(this.filter_floating_point_precision);
    assert_type_string(this.filter_base_model);
    assert_type_string(this.filter_query);
    assert_type_boolean(this.filter_show_only_used);

    assert_number_gte_0(this.index_page);

    assert_true(this.sort_columns_map.size() == 0 || this.sort_columns_map.size() == 1);

    for (let [key, value] of Object.entries(this.sort_columns_map.to_object())) {
      assert_type_enum(value, ENUM__sort_direction, { key });

      assert_array_includes(DTODiffusionModelUDBase.SORT_KEYS, key, { key });
    }
  }

  is_filter_base_model_all() {
    return this.filter_base_model === '';
  }
}
